module.exports = "/_next/static/images/HeroMobile-73eccd661f3b5c1540055f3e5b89b70d.webp";